import { isSameDay } from "date-fns";

import { Appointment } from "api/types/appointments";
import { BILLING_TYPES } from "@constants/index";
import { findDifferenceInMinutes } from "utils/findDifferenceInMinutes";

export const BILLING_TYPE_I18N_KEYS: Record<keyof typeof BILLING_TYPES, string> = {
  CAREGIVER_TRAINING: "caregiverTraining",
  ASSESSMENT: "assessment",
  IN_PERSON_ASSESSMENT: "assessmentInPerson",
  DIRECT_THERAPY: "directTherapy",
  ORIENTATION: "orientation",
  TREATMENT_PLAN_REVIEW: "treatmentPlanReview",
  CAREGIVER_MEDIATED: "caregiverMediated",
};

export const sortCallsByScheduledDate = (calls: Appointment[]) => {
  return calls.sort(
    (a, b) => new Date(a.scheduled_date).getTime() - new Date(b.scheduled_date).getTime()
  );
};

export const processCallsForNextAppointment = (calls: Appointment[] | null) => {
  if (!calls || calls.length === 0) return [];

  const activeCalls = calls.filter(
    (call) =>
      !call.end_date &&
      findDifferenceInMinutes(new Date(), call.scheduled_date) < call.call_duration
  );

  if (activeCalls.length === 0) return [];

  const sortedCalls = sortCallsByScheduledDate(activeCalls);

  const closestCall = sortedCalls[0];
  const closestDate = new Date(closestCall.scheduled_date);

  return sortedCalls.filter((call) => isSameDay(new Date(call.scheduled_date), closestDate));
};

export const getCallsByDate = (calls: Appointment[], selectedDate: Date) => {
  if (!calls || calls.length === 0) return [];

  const callsForDate = calls.filter((call) =>
    isSameDay(new Date(call.scheduled_date), selectedDate)
  );

  return sortCallsByScheduledDate(callsForDate);
};
